export function buildWillClause(title, code) {
  return `I direct that my 30-second video message titled "${title}" be accessed using the "My Last Message" application with Unlock Code: ${code}`;
}

export function printCertificate(title, code) {
  const w = window.open("", "_blank");
  if (!w) return;
  const doc = w.document;

  const style = doc.createElement("style");
  style.textContent = `
    body{font-family:Georgia,serif;background:#0A0D14;color:#F8FAFC;padding:60px;text-align:center}
    .frame{border:2px solid #D4AF37;border-radius:16px;padding:60px 40px;max-width:640px;margin:0 auto}
    h1{font-size:34px;color:#FDE68A;margin:0 0 8px}
    .sub{color:#94A3B8;font-size:14px;letter-spacing:3px;text-transform:uppercase;margin-bottom:40px}
    .code{font-family:monospace;font-size:32px;letter-spacing:6px;color:#D4AF37;font-weight:bold;margin:30px 0;word-break:break-all}
    .site{font-size:15px;letter-spacing:1px;color:#cbd5e1;margin-top:30px;padding-top:24px;border-top:1px solid rgba(212,175,55,.25)}
    .msg b{color:#F8FAFC}
  `;
  doc.head.appendChild(style);
  doc.title = "Unlock Certificate — My Last Message";

  const frame = doc.createElement("div");
  frame.className = "frame";

  const sub = doc.createElement("div");
  sub.className = "sub";
  sub.textContent = "My Last Message";

  const h1 = doc.createElement("h1");
  h1.textContent = "Unlock Certificate";

  const msg = doc.createElement("p");
  msg.className = "msg";
  msg.style.color = "#94A3B8";
  msg.appendChild(doc.createTextNode("Message: "));
  const msgVal = doc.createElement("b");
  msgVal.textContent = title;
  msg.appendChild(msgVal);

  const codeEl = doc.createElement("div");
  codeEl.className = "code";
  codeEl.textContent = code;

  const site = doc.createElement("div");
  site.className = "site";
  site.textContent = "www.mylastmessage.com.au";

  frame.append(sub, h1, msg, codeEl, site);
  doc.body.appendChild(frame);

  w.focus();
  w.print();
}
